import * as React from 'react';
import { Svg } from '../svg';

function SvgErrorIcon({ title, titleId, ...props }, svgRef) {
  return (
    <Svg
      width="1em"
      height="1em"
      viewBox="0 0 110 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M41.563 23.25h25.874L85.75 41.563v25.874L67.437 85.75H41.564L23.25 67.437V41.564L41.563 23.25z"
        fill="#FFD557"
        stroke="#FFD557"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.5 42v12.5M54.5 67h.031"
        stroke="#AC8600"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

const ForwardRef = React.forwardRef(SvgErrorIcon);
export default ForwardRef;
